<template>
  <element>
    <SearchBar @change="search" />
    <v-row no-gutters class="spacer-row align-items-center justify-content-center">
      <v-progress-circular
        v-if="keyword.length > 0 && (completedCategoryCount < categoryCount)"
        indeterminate
        color="#033e8c"
      ></v-progress-circular>
    </v-row>
    <v-row no-gutters class="d-flex align-items-center justify-content-center">
      <h5 class="hint" v-if="noResults">{{ $t('searchPage.noResults') }}</h5>
    </v-row>
    <v-list class="list-control">
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        class="list-item"
        @click="onItemClick(item)"
      >
        <SearchResultEntry 
          :text="item.text" 
          :document_type_id="item.document_type_id" 
          :data_id="item.data_id" 
          :keyword="keyword" 
          :request="requst" />
      </v-list-item>
    </v-list>
  </element>
</template>

<script>
import SearchBar from '@/components/search/SearchBar.vue';
import SearchResultEntry from '@/components/search/SearchResultEntry.vue';

export default {
  name: "SearchPage",
  props: {},
  components: {
    SearchBar,
    SearchResultEntry
  },
  data () {
    return {
      keyword: '',
      maxEntry: 5,
      categoryCount: 5,
      completedCategoryCount: 0,
      items: [],
      idFieldList: [
        '',
        'car_id',
        '',
        'part_id',
        'user_id'
      ],
      requestId: 0,
      noResults: false
    }
  },
  methods: {
    lookForSearchField(data, id, category) {
      var value;
      for (value of Object.values(data)) {
        if ((value && typeof(value) === "string" && value.length > 0) 
          && value.toLowerCase().includes(this.keyword.toLowerCase())) {
          this.items.push({
            text: value,
            document_type_id: category,
            data_id: id
          })

          break;
        }
      }
    },
    retrieveSearchResult(url, category, id) {
      this.axios.get(url, {}, { withCredentials: true })
        .then(response => {
          if (id === this.requestId) {
            response.data.data.forEach(element => {
              this.lookForSearchField(element, element[this.idFieldList[category]], category)
            });
            this.completedCategoryCount++;
          }
          
        })
        .catch(error => {
          console.log("Other error", error)
          if (id === this.requestId) {
            this.completedCategoryCount++;
          }
        })
    },
    search(value) {
      
      if (this.keyword === value) {
        return
      }

      if (!value || value.length <= 2) {
        this.keyword = ''
        this.items = []
        this.completedCategoryCount = 0
        return
      }

      this.requestId++
      this.completedCategoryCount = 0
      this.items = []
      this.keyword = value

      let url = "/search/cars/" + value + "/" + this.maxEntry
      this.retrieveSearchResult(url, 1, this.requestId)

      url = "/search/parts/" + value + "/" + this.maxEntry
      this.retrieveSearchResult(url, 3, this.requestId)

      url = "/search/users/" + value + "/" + this.maxEntry
      this.retrieveSearchResult(url, 4, this.requestId)

      url = "/search/products/" + value + "/" + this.maxEntry
      this.retrieveSearchResult(url, 5, this.requestId)

      url = "/search/customers/" + value + "/" + this.maxEntry
      this.retrieveSearchResult(url, 8, this.requestId)
    },
    onItemClick(item) {
      console.log("DOCTYPEID", typeof(item.document_type_id))
      switch(item.document_type_id) {
        case 1:
          this.$router.push({ name: 'cardetails', params: { id: item.data_id }})
          break
        case 3:
          this.$router.push({ name: 'part', params: { id: item.data_id }})
          break
      }
    }
  },
  watch: {
    completedCategoryCount: function () {
      if (this.completedCategoryCount === this.categoryCount && this.items.length === 0) {
        this.noResults = true
      } else {
        this.noResults = false
      }
    }
  }
}
</script>

<style scoped>
.spacer-row {
  height: 3.5rem;
}

.hint {
  color: #9e9e9e;
}

.theme--light.v-list {
  padding: 0 !important;
}

.theme--light.v-list-item {
  min-height: 2.4375rem !important;
  height: 2.4375rem !important;
  margin-bottom: 1rem !important;
}
</style>